/**
 * Adds functionality to the password visibility toggle button.
 *
 * Example:
 *  %div{data: {controller: "password-visibility"}}
 *    = form.label :password
 *    .d-flex
 *      = form.password_field :password, class: "form-control", data: {"password-visibility-target": "input"}
 *      %button.password-visibility-toggle{ type: "button", "data-action": "password-visibility#toggle" }
 *        %span{ "data-password-visibility-target": "icon", class: "d-none" }= niiwin_display_icon(:fas, "eye")
 *        %span{ "data-password-visibility-target": "icon" }= niiwin_display_icon(:fas, "eye-slash")
 */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "icon"];

  connect() {
    this.hidden = this.inputTarget.type === "password";
  }

  toggle(event) {
    event.preventDefault();

    this.inputTarget.type = this.hidden ? "text" : "password";
    this.hidden = !this.hidden;

    this.iconTargets.forEach((icon) => icon.classList.toggle("d-none"));
  }
}
